import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import api from './api';
import { State } from './configuration';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    menu:null,
    user: null,
    token: null,
    expireTime: null,
    gatewayTransaction: null,
    lastCod: null,
    onlyActives: true,
    gatewayTransactionConfirmed: false,
    transactionIsPendingPayment: false,
    pendingPaymentsIds: [],
    transactionProjectId: null,
    business: null,
    requesting: null,
    proyectId: null,
    currentInvestmentId: null,
    isLastInvestment: false,
    lastSimulation: null,
    amountFinanced: null,
    amountPymes: null,
    amountRenta: null,
    questionId: null,
    routes: null,
    ip:null,
    transferencias:null,
    businesSelected:null,
    businessLink:null,
    showPanelInv:null,
    siiConfigurations:null,
    openMenuPanel: false,
    claveSii:null,
    certificadoSii:null,
    miperfil:null,
    empresas_usuario:null,
    control_account:null,
    showMenuTutorial:false,
    mfa: null,
    valid: null,
    privacity_check:null,
    liquitech: false,
    temp_token: null,
  },
  mutations: {
    setQuestionId(state, id) {
      state.questionId = id;
    },
    clearQuestionId(state) {
      state.questionId = null;
    },
    hideOrNot(state, newState) {
      state.onlyActives = newState;
    },
    setCurrentInvestment(state, { investmentId, isLastInvestment, proyectId }) {
      state.currentInvestmentId = investmentId;
      state.isLastInvestment = isLastInvestment;
      state.proyectId = proyectId;
    },
    setUser(state, user) {
      state.user = user;
    },
    setToken(state, token) {
      state.token = token;
    },
    setBusiness(state, business) {
      state.business = business;
    },
    setRequesting(state, request) {
      state.requesting = request
    },
    setEmpresasCount(state, count) {
      // @ts-ignore
      state.user.empresas_count = count;
    },
    setExpireTime(state, expireTime) {
      state.expireTime = expireTime;
    },
    deleteSimulation(state) {
      state.lastSimulation = null;
    },
    logout(state) {
        state.user = null;
        state.token = null;
        state.expireTime = null;
        state.lastSimulation = null;
        state.menu = null;
        state.mfa = null;
        state.valid = null;
        state.control_account = null;
        state.privacity_check = null;
        state.temp_token = null;
        state.showMenuTutorial = false;
        state.liquitech = false;
    },
    showMenuTutorial(state, payload){
      state.showMenuTutorial = payload;
    },
    logAndReconnect(state) {
      state.user = null;
      state.expireTime = null;
      state.lastSimulation = null;
    },
    setGatewayTransaction(state, transaction) {
      state.gatewayTransaction = transaction;
      state.gatewayTransactionConfirmed = false;
      state.transactionIsPendingPayment = false;
    },
    resetGatewayTransactionConfirmation(state) {
      state.gatewayTransactionConfirmed = false;
    },
    setLastCod(state, cod) {
      state.lastCod = cod;
    },
    confirmGatewayTransaction(state) {
      state.gatewayTransactionConfirmed = true;
    },
    setTransactionPendingPayment(state) {
      state.transactionIsPendingPayment = true;
    },
    setTransactionPaymentType(state, id) {
      // @ts-ignore
      state.gatewayTransaction.pago_deta_tipo_id = id;
    },
    setPendingPaymentsIds(state, ids) {
      state.pendingPaymentsIds = ids;
    },
    setTransactionProjectId(state, id) {
      state.transactionProjectId = id;
    },
    setLastSimulation(state, simulation) {
      state.lastSimulation = simulation;
    },
    setAmountFinanced(state, amountFinanced) {
      state.amountFinanced = amountFinanced;
    },
    setAmountDataHome(state, dataHome){
      state.amountFinanced = dataHome.amountFinanced;
      if(dataHome.amountPymes)
        state.amountPymes = dataHome.amountPymes;
      if(dataHome.amountRenta)
        state.amountRenta = dataHome.amountRenta;
    },
    setRoutes(state, route) {
      state.routes = route;
    },
    setIp(state,payload){
      state.ip = payload
    },

    setTransferencias(state,payload){
      state.transferencias = payload
    },
    setMenu(state,payload){
      state.menu = payload
    },
    setBusinessSelected(state,payload){
      state.businesSelected = payload
    },
    setBusinessLink(state,payload){
      state.businessLink = payload
    },
    setShowPanelInv(state,payload){
      state.showPanelInv = payload
    },
    setsiiConfigurations(state,payload){
      state.siiConfigurations = payload
    },
    setOpenMenuPanel(state, estado){
      state.openMenuPanel = estado;
    },
    setclaveSii(state,payload){
      state.claveSii = payload
    },
    setcertificadoSii(state,payload){
      state.certificadoSii = payload
    },
    setmiperfil(state,payload){
      state.miperfil = payload
    },
    setEmpresas(state,payload){
     state.empresas_usuario = payload;
    },
    setControlAccount(state, payload){
      state.control_account = payload;
    },
    setMFA(state, active){
      state.mfa = active;
    },
    setValid(state, access){
      state.valid = access;
    },
    setPrivacityCheck(state, checked){
      state.privacity_check = checked;
    },
    setLiquitech(state,payload){
      state.liquitech = payload
    },
    setTempToken(state, token){
      state.temp_token = token;
    },
  },
  getters: {
    canShowPendingPayments: state => (ids: Array<number>) => {
      return false;
      // @ts-ignore
      // return !(ids.map((id: number) => state.pendingPaymentsIds.includes(id)).every((val) => val == true) && ids.length == state.pendingPaymentsIds.length)
    },
    canShowSubmenu: function (state) {
      return function () {
        // @ts-ignore
        const selectedId = state.businesSelected && state.businesSelected.empresa_usuario_auth;
        if (!selectedId) return false;

        // @ts-ignore
        return selectedId.role_id === 1;
      };
    },
    canNavigate: state => () => {
      
      if(!state.user) {
        return false;
      }
      
      if(state.empresas_usuario == null) {
        return false;
      }

      const empresas_count = state.empresas_usuario;
      // @ts-ignore
      if(empresas_count > 0) {
        
        const selectedBusiness = state.businesSelected;
        if(!selectedBusiness) {
          return false;
        }
        
        // @ts-ignore
        const result = selectedBusiness.radian_empresa ? selectedBusiness.radian_empresa.estado : false;
        // @ts-ignore
        return result;
      }
      return false;
    }
  },
  actions: {}
});
